import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import PropTypes from 'prop-types';
import createRef from '@roo/create-react-ref/createRef';
import { disableBodyScroll, enableBodyScroll } from '../../_utils/Dom';
import Portal from '../Portal';

var AdvancedPortal = /*#__PURE__*/function (_React$Component) {
  _inherits(AdvancedPortal, _React$Component);

  var _super = _createSuper(AdvancedPortal);

  function AdvancedPortal() {
    var _this;

    _classCallCheck(this, AdvancedPortal);

    _this = _super.apply(this, arguments);
    _this.isRendered = false;
    _this.portalRef = createRef();

    _this.handleFocus = function () {
      var _this$props = _this.props,
          autoFocus = _this$props.autoFocus,
          visible = _this$props.visible;

      if (autoFocus && visible && _this.portalRef && _this.portalRef.current) {
        _this.portalRef.current.focus();
      }
    };

    _this.handlePortalRendered = function () {
      _this.isRendered = true;
      var onRendered = _this.props.onRendered;

      if (onRendered) {
        onRendered();
      }
    };

    return _this;
  }

  _createClass(AdvancedPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleFocus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prveProps) {
      var _this$props2 = this.props,
          visible = _this$props2.visible,
          scrollable = _this$props2.scrollable;

      if (this.props.disabled) {
        return;
      }

      if (prveProps.visible !== visible) {
        this.handleFocus();
      }

      if (visible && !scrollable) {
        disableBodyScroll();
      } else {
        enableBodyScroll();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.visible && !this.props.disabled) {
        enableBodyScroll();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          visible = _a.visible,
          lazy = _a.lazy,
          style = _a.style,
          zIndex = _a.zIndex,
          children = _a.children,
          position = _a.position,
          container = _a.container,
          disabled = _a.disabled,
          scrollable = _a.scrollable,
          others = __rest(_a, ["visible", "lazy", "style", "zIndex", "children", "position", "container", "disabled", "scrollable"]); // if visible false && haven’t rendered, prevent rendering


      if (!this.isRendered && !visible) {
        return null;
      } // eslint-disable-next-line


      var childrenVisible = !this.isRendered ? visible : lazy ? true : visible;
      var sty = visible ? _Object$assign(_Object$assign({}, style), {
        position: position,
        zIndex: zIndex,
        width: '100%',
        top: 0,
        left: 0
      }) : {
        display: 'none'
      };
      return /*#__PURE__*/React.createElement(Portal, {
        disabled: disabled,
        container: container,
        onRendered: this.handlePortalRendered
      }, childrenVisible ? /*#__PURE__*/React.createElement("div", _Object$assign({}, others, {
        ref: this.portalRef,
        style: sty
      }), children) : null);
    }
  }]);

  return AdvancedPortal;
}(React.Component);

AdvancedPortal.defaultProps = {
  visible: false,
  lazy: false,
  zIndex: 1000,
  scrollable: true,
  container: undefined,
  position: 'absolute',
  autoFocus: false
};
AdvancedPortal.propTypes = {
  visible: PropTypes.bool,
  lazy: PropTypes.bool,
  zIndex: PropTypes.number,
  scrollable: PropTypes.bool,
  autoFocus: PropTypes.bool,
  position: PropTypes.oneOf(['fixed', 'absolute']),
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};
export default AdvancedPortal;